@if ((appFacadeService.getTransactionLoaded() | async) && (appFacadeService.isPaymentOpen() | async)) { @if (appFacadeService.getPaymentAppInput() | async; as paymentAppInput) {
<div>
    <por-payment-app-credit-card
        id="paymentAppCreditCard"
        *axLazyElement="porPayURL"
        [paymentAppInput]="paymentAppInput"
        (paymentAppOutput)="appFacadeService.onPaymentFinished($any($event))"></por-payment-app-credit-card>
</div>
} } @else {
<por-busy-indicator [message]="'Loading' | translate" />
} @if (appFacadeService.isDialogEnabled() | async) {
<por-app-confirm-dialog [message]="(appFacadeService.getPaymentError() | async) ?? ''" (confirmed)="appFacadeService.closePaymentDialog()" [externalClass]="'none'"></por-app-confirm-dialog>
}
